import { useRouter } from 'next/router';

import ClickEventLogger from '@/components/common/ClickEventLogger';
import LinkTag from '@/components/common/LinkTag';
import HospitalListItem, { HospitalListItemProps } from '@/components/hospital/HospitalListItem/HospitalListItem';
import { getDiagnosisStateText } from '@/utils/format';
import { getPageName } from '@/utils/logger';

interface Props extends HospitalListItemProps {
  index: number;
}
const HospitalSearchEventItem = ({
  imageUrl,
  status,
  name,
  distance,
  rating,
  address,
  badges,
  reviewTotalCount,
  isBookable = false,
  representativeDepartmentName,
  operationDisplay,
  adBanners,
  hospitalPid,
  index,
  doctorDetailPageHref = '',
  onClickMoveToDoctorDetail,
  onClickAdBanner,
  hasNonF2fDoctors,
}: Props) => {
  const router = useRouter();

  return (
    <ClickEventLogger
      pageName={getPageName(router)}
      eventName='click_hospital'
      payload={{
        section: isBookable ? 'quick_search' : 'nearby_search',
        position: index,
        hospital_id: hospitalPid,
        status: getDiagnosisStateText(status),
      }}
    >
      <LinkTag onClickNavigateToScreen={onClickMoveToDoctorDetail} href={doctorDetailPageHref}>
        <HospitalListItem
          imageUrl={imageUrl}
          distance={distance}
          representativeDepartmentName={representativeDepartmentName}
          operationDisplay={operationDisplay}
          adBanners={adBanners}
          status={status}
          name={name}
          rating={rating}
          reviewTotalCount={reviewTotalCount}
          address={address}
          badges={badges}
          hospitalPid={hospitalPid}
          onClickMoveToDoctorDetail={onClickMoveToDoctorDetail}
          onClickAdBanner={onClickAdBanner}
          doctorDetailPageHref={doctorDetailPageHref}
          isBookable={isBookable}
          hasNonF2fDoctors={hasNonF2fDoctors}
        />
      </LinkTag>
    </ClickEventLogger>
  );
};

export default HospitalSearchEventItem;
